module.exports = __webpack_public_path__ + "img/quanyi2_icon.d8161acc.svg";